import { Component, input, computed, effect, ChangeDetectionStrategy, inject, output } from '@angular/core';
import { FormsModule, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { OtpConfig, OtpLogin } from 'shared';

import { ButtonComponent } from '../../base';
import { CheckboxComponent, TextInputComponent } from '../../form-inputs';
import { FormGridComponent, FormSectionComponent } from '../../layouts';

@Component({
  selector: 'lib-signup-form',
  standalone: true,
  imports: [
    ButtonComponent,
    FormGridComponent,
    FormsModule,
    ReactiveFormsModule,
    TextInputComponent,
    FormSectionComponent,
    CheckboxComponent,
  ],
  templateUrl: './signup-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './signup-form.component.css',
})
export class SignupFormComponent {
  private fb = inject(NonNullableFormBuilder);

  public otpConfig = input.required<OtpConfig | undefined>();

  readonly signup = output<OtpLogin>();

  showFormErrors: boolean = false;
  signupForm = this.fb.group({
    name: ['', { validators: Validators.required }],
    surname: ['', { validators: Validators.required }],
    email: ['', { validators: [Validators.required, Validators.email] }],
    termsAndConditions: [false],
  });

  protected hasTermsOrPrivacy = computed(() => {
    const config = this.otpConfig();
    return !!(config?.liabilityDisclaimer || config?.privacyPolicy);
  });

  constructor() {
    effect(() => {
      const termsControl = this.signupForm.get('termsAndConditions');
      if (termsControl) {
        if (this.hasTermsOrPrivacy()) {
          termsControl.setValidators(Validators.requiredTrue);
        } else {
          termsControl.clearValidators();
        }
        termsControl.updateValueAndValidity();
      }
    });
  }

  submit() {
    if (this.signupForm.invalid) {
      this.showFormErrors = true;
    } else {
      this.signup.emit(this.signupForm.value as OtpLogin);
    }
  }
}
